var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-column align-center"},[_vm._m(0),_c('div',{staticClass:"btn",on:{"click":_vm.down}},[_vm._v("点击下载APP")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex head"},[_c('div',{staticClass:"icon"})])
}]

export { render, staticRenderFns }